interface IChatModel {
	id: string;
	type: 'RECRUITMENT' | 'CONSULTING';
	target: string;
	city: string;
	picture: string;
	conversation: IChatConversationModel[];
	status: 0 | 1 | 2;
	lastMessage: IChatlastMessage;
	ownersId: string[];
	ownersData: IChatOwnersData[];
	createAt: any;
}

interface IChatOwnersData {
	uid: string;
	picture: string;
	name: string;
}

interface IChatlastMessage {
	uid: string;
	read: boolean;
}

interface IChatConversationModel {
	ownerId: string;
	message: string;
	type: IChatConversationTypeModel;
	url: string;
	createAt: any;
	fileName?: string;
}

type IChatConversationTypeModel = 'text' | 'image' | 'voice' | 'file';

const defaultChat: IChatModel = {
	id: '',
	target: '',
	city: '',
	conversation: [],
	status: 0,
	picture: '',
	lastMessage: {
		uid: '',
		read: false
	},
	ownersId: [],
	ownersData: [],
	createAt: new Date().toJSON()
};
export default IChatModel;
export type { IChatModel, IChatConversationModel, IChatConversationTypeModel, IChatOwnersData, IChatlastMessage };
export { defaultChat };
